import { create } from 'zustand';
const useTasksDrawerStore = create((set)=>({
        isDrawerOpen: false,
        setIsDrawerOpen: (open)=>set({
                isDrawerOpen: open
            }),
        toggle: ()=>set((s)=>({
                    isDrawerOpen: !s.isDrawerOpen
                }))
    }));
export { useTasksDrawerStore };
export function useTasksDrawer() {
    const isDrawerOpen = useTasksDrawerStore((s)=>s.isDrawerOpen);
    const setIsDrawerOpen = useTasksDrawerStore((s)=>s.setIsDrawerOpen);
    const toggle = useTasksDrawerStore((s)=>s.toggle);
    return {
        isDrawerOpen,
        setIsDrawerOpen,
        toggle
    };
}
